import { BaseModel } from "./_base.model";

export abstract class BaseRestModel extends BaseModel {
}